import { useState } from "react";

import {
    ClipboardList,
    User,
    Store,
    Bike,
    CreditCard,
    Clock3,
    Activity,
    BadgeIndianRupee,
} from "lucide-react";

import OverviewTab from "./OverviewTab";
import CustomerTab from "./CustomerTab";
import ProviderTab from "./ProviderTab";
import DeliveryTab from "./DeliveryTab";
import PaymentTab from "./PaymentTab";
import TimelineTab from "./TimelineTab";
import ActivityTab from "./ActivityTab";
import RefundTab from "./RefundTab";

import "./OrderTabs.css";

function OrderTabs({ order }) {

    const [activeTab, setActiveTab] = useState("overview");

    const tabs = [
        {
            key: "overview",
            label: "Overview",
            icon: <ClipboardList size={18} />,
        },
        {
            key: "customer",
            label: "Customer",
            icon: <User size={18} />,
        },
        {
            key: "provider",
            label: "Provider",
            icon: <Store size={18} />,
        },
        {
            key: "delivery",
            label: "Delivery",
            icon: <Bike size={18} />,
        },
        {
            key: "payment",
            label: "Payment",
            icon: <CreditCard size={18} />,
        },
        {
            key: "timeline",
            label: "Timeline",
            icon: <Clock3 size={18} />,
        },
        {
            key: "activity",
            label: "Activity",
            icon: <Activity size={18} />,
        },
        {
            key: "refund",
            label: "Refund",
            icon: <BadgeIndianRupee size={18} />,
        },
    ];

    return (

        <div className="order-tabs-container">

            <div className="tabs-header">

                {tabs.map((tab) => (

                    <button
                        key={tab.key}
                        className={
                            activeTab === tab.key
                                ? "tab-btn active"
                                : "tab-btn"
                        }
                        onClick={() =>
                            setActiveTab(tab.key)
                        }
                    >
                        {tab.icon}
                        {tab.label}
                    </button>

                ))}

            </div>

            <div className="tab-content">

                {activeTab === "overview" && (
                    <OverviewTab order={order} />
                )}

                {activeTab === "customer" && (
                    <CustomerTab order={order} />
                )}

                {activeTab === "provider" && (
                    <ProviderTab order={order} />
                )}

                {activeTab === "delivery" && (
                    <DeliveryTab order={order} />
                )}

                {activeTab === "payment" && (
                    <PaymentTab order={order} />
                )}

                {activeTab === "timeline" && (
                    <TimelineTab order={order} />
                )}

                {activeTab === "activity" && (
                    <ActivityTab order={order} />
                )}

                {activeTab === "refund" && (
                    <RefundTab order={order} />
                )}

            </div>

        </div>

    );

}

export default OrderTabs;